const _ = require('lodash'); 


const nouns = [
    "aardvark",
    "air",
    "airplane",
    "airport",
    "alarm",
    "alligator",
    "alphabet",
    "ambulance",
    "animal",
    "ankle",
    "army",
    "answer",
    "ant",
    "antelope",
    "apple",
    "arm",
    "armchair",
    "arrow",
    "asparagus",
    "baby",
    "back",
    "backbone",
    "bacon",
    "badge",
    "badger",
    "bag",
    "bagpipe",
    "bait",
    "bakery",
    "ball",
    "balloon",
    "bamboo",
    "banana",
    "band",
    "bandana",
    "bangle",
    "banjo",
    "bank",
    "baseball",
    "basket",
    "basketball",
    "bat",
    "bath",
    "bathroom",
    "bathtub",
    "battery",
    "battle",
    "bay",
    "beach",
    "bead",
    "bean",
    "bear",
    "beard",
    "beast",
    "beat",
    "beauty",
    "beaver",
    "bed",
    "bedroom",
    "bee",
    "beef",
    "beetle",
    "bell",
    "belt",
    "bench",
    "beret",
    "berry",
    "bicycle",
    "bike",
    "bird",
    "birthday",
    "bite",
    "black",
    "blade",
    "blanket",
    "block",
    "blood",
    "blouse",
    "blow",
    "board",
    "boat",
    "bobcat",
    "body",
    "bolt",
    "bone",
    "bonsai",
    "book",
    "bookcase",
    "booklet",
    "boot",
    "border",
    "bottle",
    "bottom",
    "boundary",
    "bow",
    "bowling",
    "box",
    "boy",
    "brain",
    "brake",
    "branch",
    "brass",
    "bread",
    "break",
    "breakfast",
    "breath",
    "brick",
    "bridge",
    "broccoli",
    "brochure",
    "brother",
    "brush",
    "bubble",
    "bucket",
    "building",
    "bulb",
    "bull",
    "bulldozer",
    "bumper",
    "bun",
    "bus",
    "bush",
    "butter",
    "button",
    "cabbage",
    "cactus",
    "cafe",
    "cake",
    "calculator",
    "calendar",
    "calf",
    "call",
    "camel",
    "camera",
    "camp",
    "candle",
    "canoe",
    "canvas",
    "cap",
    "captain",
    "car",
    "card",
    "cardboard",
    "cardigan",
    "carpenter",
    "carrot",
    "cartoon",
    "cat",
    "caterpillar",
    "cathedral",
    "cattle",
    "cauliflower",
    "cave",
    "CD",
    "ceiling",
    "celery",
    "cello",
    "cement",
    "cemetery",
    "cereal",
    "chain",
    "chair",
    "chalk",
    "channel",
    "character",
    "cheek",
    "cheese",
    "cheetah",
    "cherry",
    "chess",
    "chest",
    "chick",
    "chicken",
    "children",
    "chimpanzee",
    "chin",
    "chive",
    "chocolate",
    "church",
    "cicada",
    "cinema",
    "circle",
    "city",
    "clam",
    "clarinet",
    "click",
    "clock",
    "close",
    "closet",
    "cloth",
    "cloud",
    "cloudy",
    "coach",
    "coal",
    "coast",
    "coat",
    "cobweb",
    "cockroach",
    "cocoa",
    "coffee",
    "coil",
    "coin",
    "coke",
    "cold",
    "collar",
    "college",
    "colt",
    "comb",
    "comics",
    "comma",
    "computer",
    "copy",
    "corn",
    "cost",
    "cotton",
    "couch",
    "cougar",
    "country",
    "course",
    "court",
    "cousin",
    "cow",
    "crab",
    "crack",
    "cracker",
    "crate",
    "crayfish",
    "crayon",
    "cream",
    "creek",
    "cricket",
    "crocodile",
    "crop",
    "crow",
    "crowd",
    "crown",
    "cucumber",
    "cup",
    "cupboard",
    "curtain",
    "curve",
    "cushion",
    "cyclone",
    "dad",
    "daffodil",
    "daisy",
    "dance",
    "daughter",
    "day",
    "deer",
    "denim",
    "dentist",
    "desert",
    "desk",
    "dessert",
    "detective",
    "dew",
    "diamond",
    "dictionary",
    "dinghy",
    "dinosaur",
    "dirt",
    "dish",
    "dog",
    "doll",
    "dollar",
    "door",
    "dragon",
    "dragonfly",
    "drain",
    "drawer",
    "dream",
    "dress",
    "dresser",
    "drill",
    "drink",
    "drum",
    "dryer",
    "duck",
    "duckling",
    "dungeon",
    "dust",
    "eagle",
    "ear",
    "earth",
    "earthquake",
    "eel",
    "egg",
    "eggplant",
    "elbow",
    "elephant",
    "energy",
    "engine",
    "equipment",
    "evening",
    "eye",
    "eyebrow",
    "face",
    "fact",
    "factory",
    "fairies",
    "family",
    "fan",
    "fang",
    "farm",
    "fear",
    "feast",
    "feather",
    "feet",
    "ferryboat",
    "field",
    "fight",
    "finger",
    "fire",
    "fireplace",
    "fish",
    "flag",
    "flame",
    "flood",
    "floor",
    "flower",
    "flute",
    "fly",
    "foam",
    "fog",
    "food",
    "foot",
    "football",
    "forehead",
    "forest",
    "fork",
    "fountain",
    "fox",
    "frame",
    "freckle",
    "freezer",
    "frog",
    "frost",
    "fruit",
    "fuel",
    "fur",
    "furniture",
    "game",
    "garage",
    "garden",
    "garlic",
    "gas",
    "gate",
    "gear",
    "ghost",
    "giraffe",
    "girl",
    "glass",
    "glove",
    "glue",
    "goal",
    "goat",
    "gold",
    "goldfish",
    "golf",
    "gorilla",
    "government",
    "grape",
    "grass",
    "grasshopper",
    "grease",
    "grill",
    "group",
    "guitar",
    "gum",
    "gym",
    "gymnast",
    "hail",
    "hair",
    "haircut",
    "hall",
    "hamburger",
    "hammer",
    "hamster",
    "hand",
    "handball",
    "handle",
    "hardware",
    "harmonica",
    "harmony",
    "hat",
    "hate",
    "hawk",
    "head",
    "headlight",
    "health",
    "heart",
    "heat",
    "heaven",
    "hedge",
    "height",
    "helicopter",
    "helmet",
    "help",
    "hen",
    "hill",
    "hip",
    "hippopotamus",
    "history",
    "hockey",
    "hole",
    "holiday",
    "home",
    "honey",
    "hood",
    "hook",
    "horn",
    "horse",
    "hose",
    "hospital",
    "hour",
    "house",
    "hurricane",
    "hyena",
    "ice",
    "icicle",
    "idea",
    "ink",
    "insect",
    "instrument",
    "Internet",
    "invention",
    "iron",
    "island",
    "jacket",
    "jaguar",
    "jail",
    "jam",
    "jar",
    "jaw",
    "jeans",
    "jeep",
    "jelly",
    "jellyfish",
    "jet",
    "jewel",
    "joke",
    "journey",
    "judge",
    "judo",
    "juice",
    "jump",
    "jumper",
    "kangaroo",
    "karate",
    "kayak",
    "kettle",
    "key",
    "keyboard",
    "kick",
    "kiss",
    "kitchen",
    "kite",
    "kitten",
    "knee",
    "knife",
    "knight",
    "knot",
    "lace",
    "ladybug",
    "lake",
    "lamb",
    "lamp",
    "land",
    "lasagna",
    "laugh",
    "laundry",
    "leaf",
    "leather",
    "leek",
    "leg",
    "lemonade",
    "leopard",
    "letter",
    "lettuce",
    "library",
    "lift",
    "light",
    "lightning",
    "lily",
    "line",
    "lion",
    "lip",
    "lipstick",
    "liquid",
    "list",
    "litter",
    "lizard",
    "loaf",
    "lobster",
    "lock",
    "locket",
    "locust",
    "look",
    "lotion",
    "love",
    "lunch",
    "lynx",
    "macaroni",
    "machine",
    "magazine",
    "magic",
    "magician",
    "mail",
    "mailbox",
    "mailman",
    "makeup",
    "map",
    "marble",
    "mark",
    "market",
    "mascara",
    "mask",
    "match",
    "meal",
    "meat",
    "mechanic",
    "medicine",
    "memory",
    "men",
    "menu",
    "message",
    "metal",
    "mice",
    "middle",
    "milk",
    "milkshake",
    "mint",
    "minute",
    "mirror",
    "mist",
    "mistake",
    "mitten",
    "Monday",
    "money",
    "monkey",
    "month",
    "moon",
    "morning",
    "mosquito",
    "motorboat",
    "motorcycle",
    "mountain",
    "mouse",
    "moustache",
    "mouth",
    "music",
    "mustard",
    "nail",
    "name",
    "napkin",
    "neck",
    "needle",
    "nest",
    "net",
    "news",
    "night",
    "noise",
    "noodle",
    "nose",
    "note",
    "notebook",
    "number",
    "nut",
    "oak",
    "oatmeal",
    "ocean",
    "octopus",
    "office",
    "oil",
    "olive",
    "onion",
    "orange",
    "orchestra",
    "ostrich",
    "otter",
    "oven",
    "owl",
    "ox",
    "oxygen",
    "oyster",
    "packet",
    "page",
    "pail",
    "pain",
    "paint",
    "pair",
    "pajama",
    "pamphlet",
    "pan",
    "pancake",
    "panda",
    "pansy",
    "panther",
    "pants",
    "paper",
    "parcel",
    "parent",
    "park",
    "parrot",
    "party",
    "pasta",
    "paste",
    "pastry",
    "patch",
    "path",
    "pea",
    "peace",
    "peanut",
    "pear",
    "pedestrian",
    "pelican",
    "pen",
    "pencil",
    "pepper",
    "perfume",
    "person",
    "pest",
    "pet",
    "phone",
    "piano",
    "pickle",
    "picture",
    "pie",
    "pig",
    "pigeon",
    "pillow",
    "pilot",
    "pimple",
    "pin",
    "pipe",
    "pizza",
    "plane",
    "plant",
    "plantation",
    "plastic",
    "plate",
    "playground",
    "plot",
    "pocket",
    "poison",
    "police",
    "policeman",
    "pollution",
    "pond",
    "popcorn",
    "poppy",
    "porcupine",
    "postage",
    "postbox",
    "pot",
    "potato",
    "poultry",
    "powder",
    "power",
    "price",
    "printer",
    "prison",
    "pumpkin",
    "puppy",
    "pyramid",
    "queen",
    "question",
    "quicksand",
    "quill",
    "quilt",
    "rabbit",
    "radio",
    "radish",
    "raft",
    "rail",
    "railway",
    "rain",
    "rainbow",
    "raincoat",
    "rainstorm",
    "rake",
    "rat",
    "ravioli",
    "ray",
    "recorder",
    "rectangle",
    "refrigerator",
    "reindeer",
    "relatives",
    "restaurant",
    "reward",
    "rhinoceros",
    "rice",
    "riddle",
    "ring",
    "river",
    "road",
    "roast",
    "rock",
    "roll",
    "roof",
    "room",
    "rooster",
    "rose",
    "rowboat",
    "rubber",
    "sack",
    "sail",
    "sailboat",
    "sailor",
    "salad",
    "salmon",
    "salt",
    "sand",
    "sandwich",
    "sardine",
    "sauce",
    "sausage",
    "saw",
    "saxophone",
    "scarecrow",
    "scarf",
    "school",
    "scissors",
    "scooter",
    "scorpion",
    "screw",
    "screwdriver",
    "sea",
    "seagull",
    "seal",
    "seaplane",
    "seashore",
    "season",
    "seat",
    "second",
    "seed",
    "sentence",
    "servant",
    "shade",
    "shadow",
    "shallot",
    "shampoo",
    "shark",
    "shears",
    "sheep",
    "sheet",
    "shelf",
    "shell",
    "shield",
    "ship",
    "shirt",
    "shoe",
    "shoemaker",
    "shop",
    "shorts",
    "shoulder",
    "shovel",
    "shoe",
    "side",
    "sidewalk",
    "sign",
    "signature",
    "silk",
    "silver",
    "singer",
    "sink",
    "sister",
    "skin",
    "skirt",
    "sky",
    "sled",
    "slippers",
    "slope",
    "smoke",
    "snail",
    "snake",
    "sneeze",
    "snow",
    "snowflake",
    "snowman",
    "soap",
    "soccer",
    "sock",
    "sofa",
    "softball",
    "soldier",
    "son",
    "song",
    "sound",
    "soup",
    "soybean",
    "space",
    "spade",
    "spaghetti",
    "spark",
    "sparrow",
    "spear",
    "speedboat",
    "spider",
    "spike",
    "spinach",
    "sponge",
    "spoon",
    "spot",
    "sprout",
    "spy",
    "square",
    "squash",
    "squid",
    "squirrel",
    "stage",
    "staircase",
    "stamp",
    "star",
    "station",
    "steam",
    "steel",
    "stem",
    "step",
    "stew",
    "stick",
    "stitch",
    "stinger",
    "stomach",
    "stone",
    "stool",
    "sign",
    "stopwatch",
    "store",
    "storm",
    "story",
    "stove",
    "stranger",
    "straw",
    "stream",
    "string",
    "submarine",
    "sugar",
    "suit",
    "summer",
    "sun",
    "sunshine",
    "sunflower",
    "supermarket",
    "surfboard",
    "surname",
    "surprise",
    "sushi",
    "swallow",
    "swamp",
    "swan",
    "sweater",
    "sweatshirt",
    "sweets",
    "swing",
    "switch",
    "sword",
    "swordfish",
    "syrup",
    "table",
    "tabletop",
    "tadpole",
    "tail",
    "target",
    "tax",
    "taxi",
    "tea",
    "teacher",
    "team",
    "teeth",
    "television",
    "tennis",
    "tent",
    "textbook",
    "theater",
    "thistle",
    "thought",
    "thread",
    "throat",
    "throne",
    "thumb",
    "thunder",
    "thunderstorm",
    "ticket",
    "tie",
    "tiger",
    "tile",
    "time",
    "tire",
    "toad",
    "toast",
    "toe",
    "toilet",
    "tomato",
    "tongue",
    "tooth",
    "toothbrush",
    "toothpaste",
    "top",
    "tornado",
    "tortoise",
    "tower",
    "town",
    "toy",
    "tractor",
    "traffic",
    "trail",
    "train",
    "transport",
    "tray",
    "tree",
    "triangle",
    "trick",
    "trip",
    "trombone",
    "trouble",
    "trousers",
    "truck",
    "trumpet",
    "trunk",
    "t-shirt",
    "tub",
    "tuba",
    "tugboat",
    "tulip",
    "tuna",
    "tune",
    "Turkey",
    "turnip",
    "turtle",
    "TV",
    "twig",
    "twilight",
    "twine",
    "umbrella",
    "valley",
    "van",
    "vase",
    "vegetable",
    "veil",
    "vein",
    "vessel",
    "vest",
    "violin",
    "volcano",
    "volleyball",
    "vulture",
    "wall",
    "wallaby",
    "walrus",
    "washer",
    "wasp",
    "waste",
    "watch",
    "watchmaker",
    "water",
    "waterfall",
    "wave",
    "wax",
    "weapon",
    "weasel",
    "weather",
    "wedge",
    "whale",
    "wheel",
    "whip",
    "whistle",
    "wilderness",
    "willow",
    "wind",
    "window",
    "windscreen",
    "wing",
    "winter",
    "wire",
    "wish",
    "witch",
    "wolf",
    "woman",
    "wood",
    "wool",
    "word",
    "workshop",
    "worm",
    "wound",
    "wren",
    "wrench",
    "wrinkles",
    "wrist",
    "xylophone",
    "yacht",
    "yak",
    "yard",
    "yogurt",
    "zebra",
    "zipper",
    "zoo",
];
const adjectives = [
    'aback',
    'abaft',
    'abandoned',
    'abashed',
    'aberrant',
    'abhorrent',
    'abiding',
    'abject',
    'ablaze',
    'able',
    'abnormal',
    'aboard',
    'aboriginal',
    'abortive',
    'abounding',
    'abrasive',
    'abrupt',
    'absent',
    'absorbed',
    'absorbing',
    'abstracted',
    'absurd',
    'abundant',
    'abusive',
    'acceptable',
    'accessible',
    'accidental',
    'accurate',
    'acid',
    'acidic',
    'acoustic',
    'acrid',
    'actually',
    'ad hoc',
    'adamant',
    'adaptable',
    'addicted',
    'adhesive',
    'adjoining',
    'adorable',
    'adventurous',
    'afraid',
    'aggressive',
    'agonizing',
    'agreeable',
    'ahead',
    'ajar',
    'alcoholic',
    'alert',
    'alike',
    'alive',
    'alleged',
    'alluring',
    'aloof',
    'amazing',
    'ambiguous',
    'ambitious',
    'amuck',
    'amused',
    'amusing',
    'ancient',
    'angry',
    'animated',
    'annoyed',
    'annoying',
    'anxious',
    'apathetic',
    'aquatic',
    'aromatic',
    'arrogant',
    'ashamed',
    'aspiring',
    'assorted',
    'astonishing',
    'attractive',
    'auspicious',
    'automatic',
    'available',
    'average',
    'awake',
    'aware',
    'awesome',
    'awful',
    'axiomatic',
    'bad',
    'barbarous',
    'bashful',
    'bawdy',
    'beautiful',
    'befitting',
    'belligerent',
    'beneficial',
    'bent',
    'berserk',
    'best',
    'better',
    'bewildered',
    'big',
    'billowy',
    'bite-sized',
    'bitter',
    'bizarre',
    'black',
    'black-and-white',
    'bloody',
    'blue',
    'blue-eyed',
    'blushing',
    'boiling',
    'boorish',
    'bored',
    'boring',
    'bouncy',
    'boundless',
    'brainy',
    'brash',
    'brave',
    'brawny',
    'breakable',
    'breezy',
    'brief',
    'bright',
    'bright',
    'broad',
    'broken',
    'brown',
    'bumpy',
    'burly',
    'bustling',
    'busy',
    'cagey',
    'calculating',
    'callous',
    'calm',
    'capable',
    'capricious',
    'careful',
    'careless',
    'caring',
    'cautious',
    'ceaseless',
    'certain',
    'changeable',
    'charming',
    'cheap',
    'cheerful',
    'chemical',
    'chief',
    'childlike',
    'chilly',
    'chivalrous',
    'chubby',
    'chunky',
    'clammy',
    'classy',
    'clean',
    'clear',
    'clever',
    'cloistered',
    'cloudy',
    'closed',
    'clumsy',
    'cluttered',
    'coherent',
    'cold',
    'colorful',
    'colossal',
    'combative',
    'comfortable',
    'common',
    'complete',
    'complex',
    'concerned',
    'condemned',
    'confused',
    'conscious',
    'cooing',
    'cool',
    'cooperative',
    'coordinated',
    'courageous',
    'cowardly',
    'crabby',
    'craven',
    'crazy',
    'creepy',
    'crooked',
    'crowded',
    'cruel',
    'cuddly',
    'cultured',
    'cumbersome',
    'curious',
    'curly',
    'curved',
    'curvy',
    'cut',
    'cute',
    'cute',
    'cynical',
    'daffy',
    'daily',
    'damaged',
    'damaging',
    'damp',
    'dangerous',
    'dapper',
    'dark',
    'dashing',
    'dazzling',
    'dead',
    'deadpan',
    'deafening',
    'dear',
    'debonair',
    'decisive',
    'decorous',
    'deep',
    'deeply',
    'defeated',
    'defective',
    'defiant',
    'delicate',
    'delicious',
    'delightful',
    'demonic',
    'delirious',
    'dependent',
    'depressed',
    'deranged',
    'descriptive',
    'deserted',
    'detailed',
    'determined',
    'devilish',
    'didactic',
    'different',
    'difficult',
    'diligent',
    'direful',
    'dirty',
    'disagreeable',
    'disastrous',
    'discreet',
    'disgusted',
    'disgusting',
    'disillusioned',
    'dispensable',
    'distinct',
    'disturbed',
    'divergent',
    'dizzy',
    'domineering',
    'doubtful',
    'drab',
    'draconian',
    'dramatic',
    'dreary',
    'drunk',
    'dry',
    'dull',
    'dusty',
    'dusty',
    'dynamic',
    'dysfunctional',
    'eager',
    'early',
    'earsplitting',
    'earthy',
    'easy',
    'eatable',
    'economic',
    'educated',
    'efficacious',
    'efficient',
    'eight',
    'elastic',
    'elated',
    'elderly',
    'electric',
    'elegant',
    'elfin',
    'elite',
    'embarrassed',
    'eminent',
    'empty',
    'enchanted',
    'enchanting',
    'encouraging',
    'endurable',
    'energetic',
    'enormous',
    'entertaining',
    'enthusiastic',
    'envious',
    'equable',
    'equal',
    'erect',
    'erratic',
    'ethereal',
    'evanescent',
    'evasive',
    'even',
    'excellent',
    'excited',
    'exciting',
    'exclusive',
    'exotic',
    'expensive',
    'extra-large',
    'extra-small',
    'exuberant',
    'exultant',
    'fabulous',
    'faded',
    'faint',
    'fair',
    'faithful',
    'fallacious',
    '0',
    'familiar',
    'famous',
    'fanatical',
    'fancy',
    'fantastic',
    'far',
    'far-flung',
    'fascinated',
    'fast',
    'fat',
    'faulty',
    'fearful',
    'fearless',
    'feeble',
    'feigned',
    'female',
    'fertile',
    'festive',
    'few',
    'fierce',
    'filthy',
    'fine',
    'finicky',
    'first',
    'five',
    'fixed',
    'flagrant',
    'flaky',
    'flashy',
    'flat',
    'flawless',
    'flimsy',
    'flippant',
    'flowery',
    'fluffy',
    'fluttering',
    'foamy',
    'foolish',
    'foregoing',
    'forgetful',
    'fortunate',
    'four',
    'frail',
    'fragile',
    'frantic',
    'free',
    'freezing',
    'frequent',
    'fresh',
    'fretful',
    'friendly',
    'frightened',
    'frightening',
    'full',
    'fumbling',
    'functional',
    'funny',
    'furry',
    'furtive',
    'future',
    'futuristic',
    'fuzzy',
    'gaping',
    'garrulous',
    'gaudy',
    'general',
    'gentle',
    'giant',
    'giddy',
    'gifted',
    'gigantic',
    'glamorous',
    'gleaming',
    'glib',
    'glistening',
    'glorious',
    'glossy',
    'godly',
    'good',
    'goofy',
    'gorgeous',
    'graceful',
    'grandiose',
    'grateful',
    'gratis',
    'gray',
    'greasy',
    'great',
    'greedy',
    'green',
    'grey',
    'grieving',
    'groovy',
    'grotesque',
    'grouchy',
    'grubby',
    'gruesome',
    'grumpy',
    'guarded',
    'guiltless',
    'gullible',
    'gusty',
    'guttural',
    'habitual',
    'half',
    'hallowed',
    'halting',
    'handsome',
    'handsomely',
    'handy',
    'hanging',
    'hapless',
    'happy',
    'hard',
    'hard-to-find',
    'harmonious',
    'harsh',
    'hateful',
    'heady',
    'healthy',
    'heartbreaking',
    'heavenly',
    'heavy',
    'hellish',
    'helpful',
    'helpless',
    'hesitant',
    'hideous',
    'high',
    'highfalutin',
    'high-pitched',
    'hilarious',
    'hissing',
    'historical',
    'holistic',
    'hollow',
    'homeless',
    'homely',
    'honorable',
    'horrible',
    'hospitable',
    'hot',
    'huge',
    'hulking',
    'humdrum',
    'humorous',
    'hungry',
    'hurried',
    'hurt',
    'hushed',
    'husky',
    'hypnotic',
    'hysterical',
    'icky',
    'icy',
    'idiotic',
    'ignorant',
    'ill',
    'illegal',
    'ill-fated',
    'ill-informed',
    'illustrious',
    'imaginary',
    'immense',
    'imminent',
    'impartial',
    'imperfect',
    'impolite',
    'important',
    'imported',
    'impossible',
    'incandescent',
    'incompetent',
    'inconclusive',
    'industrious',
    'incredible',
    'inexpensive',
    'infamous',
    'innate',
    'innocent',
    'inquisitive',
    'insidious',
    'instinctive',
    'intelligent',
    'interesting',
    'internal',
    'invincible',
    'irate',
    'irritating',
    'itchy',
    'jaded',
    'jagged',
    'jazzy',
    'jealous',
    'jittery',
    'jobless',
    'jolly',
    'joyous',
    'judicious',
    'juicy',
    'jumbled',
    'jumpy',
    'juvenile',
    'kaput',
    'keen',
    'kind',
    'kindhearted',
    'kindly',
    'knotty',
    'knowing',
    'knowledgeable',
    'known',
    'labored',
    'lackadaisical',
    'lacking',
    'lame',
    'lamentable',
    'languid',
    'large',
    'last',
    'late',
    'laughable',
    'lavish',
    'lazy',
    'lean',
    'learned',
    'left',
    'legal',
    'lethal',
    'level',
    'lewd',
    'light',
    'like',
    'likeable',
    'limping',
    'literate',
    'little',
    'lively',
    'lively',
    'living',
    'lonely',
    'long',
    'longing',
    'long-term',
    'loose',
    'lopsided',
    'loud',
    'loutish',
    'lovely',
    'loving',
    'low',
    'lowly',
    'lucky',
    'ludicrous',
    'lumpy',
    'lush',
    'luxuriant',
    'lying',
    'lyrical',
    'macabre',
    'macho',
    'maddening',
    'madly',
    'magenta',
    'magical',
    'magnificent',
    'majestic',
    'makeshift',
    'male',
    'malicious',
    'mammoth',
    'maniacal',
    'many',
    'marked',
    'massive',
    'married',
    'marvelous',
    'material',
    'materialistic',
    'mature',
    'mean',
    'measly',
    'meaty',
    'medical',
    'meek',
    'mellow',
    'melodic',
    'melted',
    'merciful',
    'mere',
    'messy',
    'mighty',
    'military',
    'milky',
    'mindless',
    'miniature',
    'minor',
    'miscreant',
    'misty',
    'mixed',
    'moaning',
    'modern',
    'moldy',
    'momentous',
    'motionless',
    'mountainous',
    'muddled',
    'mundane',
    'murky',
    'mushy',
    'mute',
    'mysterious',
    'naive',
    'nappy',
    'narrow',
    'nasty',
    'natural',
    'naughty',
    'nauseating',
    'near',
    'neat',
    'nebulous',
    'necessary',
    'needless',
    'needy',
    'neighborly',
    'nervous',
    'new',
    'next',
    'nice',
    'nifty',
    'nimble',
    'nine',
    'nippy',
    'noiseless',
    'noisy',
    'nonchalant',
    'nondescript',
    'nonstop',
    'normal',
    'nostalgic',
    'nosy',
    'noxious',
    'null',
    'numberless',
    'numerous',
    'nutritious',
    'nutty',
    'oafish',
    'obedient',
    'obeisant',
    'obese',
    'obnoxious',
    'obscene',
    'obsequious',
    'observant',
    'obsolete',
    'obtainable',
    'oceanic',
    'odd',
    'offbeat',
    'old',
    'old-fashioned',
    'omniscient',
    'one',
    'onerous',
    'open',
    'opposite',
    'optimal',
    'orange',
    'ordinary',
    'organic',
    'ossified',
    'outgoing',
    'outrageous',
    'outstanding',
    'oval',
    'overconfident',
    'overjoyed',
    'overrated',
    'overt',
    'overwrought',
    'painful',
    'painstaking',
    'pale',
    'paltry',
    'panicky',
    'panoramic',
    'parallel',
    'parched',
    'parsimonious',
    'past',
    'pastoral',
    'pathetic',
    'peaceful',
    'penitent',
    'perfect',
    'periodic',
    'permissible',
    'perpetual',
    'petite',
    'petite',
    'phobic',
    'physical',
    'picayune',
    'pink',
    'piquant',
    'placid',
    'plain',
    'plant',
    'plastic',
    'plausible',
    'pleasant',
    'plucky',
    'pointless',
    'poised',
    'polite',
    'political',
    'poor',
    'possessive',
    'possible',
    'powerful',
    'precious',
    'premium',
    'present',
    'pretty',
    'previous',
    'pricey',
    'prickly',
    'private',
    'probable',
    'productive',
    'profuse',
    'protective',
    'proud',
    'psychedelic',
    'psychotic',
    'public',
    'puffy',
    'pumped',
    'puny',
    'purple',
    'purring',
    'pushy',
    'puzzled',
    'puzzling',
    'quack',
    'quaint',
    'quarrelsome',
    'questionable',
    'quick',
    'quickest',
    'quiet',
    'quirky',
    'quixotic',
    'quizzical',
    'rabid',
    'racial',
    'ragged',
    'rainy',
    'rambunctious',
    'rampant',
    'rapid',
    'rare',
    'raspy',
    'ratty',
    'ready',
    'real',
    'rebel',
    'receptive',
    'recondite',
    'red',
    'redundant',
    'reflective',
    'regular',
    'relieved',
    'remarkable',
    'reminiscent',
    'repulsive',
    'resolute',
    'resonant',
    'responsible',
    'rhetorical',
    'rich',
    'right',
    'righteous',
    'rightful',
    'rigid',
    'ripe',
    'ritzy',
    'roasted',
    'robust',
    'romantic',
    'roomy',
    'rotten',
    'rough',
    'round',
    'royal',
    'ruddy',
    'rude',
    'rural',
    'rustic',
    'ruthless',
    'sable',
    'sad',
    'safe',
    'salty',
    'same',
    'sassy',
    'satisfying',
    'savory',
    'scandalous',
    'scarce',
    'scared',
    'scary',
    'scattered',
    'scientific',
    'scintillating',
    'scrawny',
    'screeching',
    'second',
    'second-hand',
    'secret',
    'secretive',
    'sedate',
    'seemly',
    'selective',
    'selfish',
    'separate',
    'serious',
    'shaggy',
    'shaky',
    'shallow',
    'sharp',
    'shiny',
    'shivering',
    'shocking',
    'short',
    'shrill',
    'shut',
    'shy',
    'sick',
    'silent',
    'silent',
    'silky',
    'silly',
    'simple',
    'simplistic',
    'sincere',
    'six',
    'skillful',
    'skinny',
    'sleepy',
    'slim',
    'slimy',
    'slippery',
    'sloppy',
    'slow',
    'small',
    'smart',
    'smelly',
    'smiling',
    'smoggy',
    'smooth',
    'sneaky',
    'snobbish',
    'snotty',
    'soft',
    'soggy',
    'solid',
    'somber',
    'sophisticated',
    'sordid',
    'sore',
    'sore',
    'sour',
    'sparkling',
    'special',
    'spectacular',
    'spicy',
    'spiffy',
    'spiky',
    'spiritual',
    'spiteful',
    'splendid',
    'spooky',
    'spotless',
    'spotted',
    'spotty',
    'spurious',
    'squalid',
    'square',
    'squealing',
    'squeamish',
    'staking',
    'stale',
    'standing',
    'statuesque',
    'steadfast',
    'steady',
    'steep',
    'stereotyped',
    'sticky',
    'stiff',
    'stimulating',
    'stingy',
    'stormy',
    'straight',
    'strange',
    'striped',
    'strong',
    'stupendous',
    'stupid',
    'sturdy',
    'subdued',
    'subsequent',
    'substantial',
    'successful',
    'succinct',
    'sudden',
    'sulky',
    'super',
    'superb',
    'superficial',
    'supreme',
    'swanky',
    'sweet',
    'sweltering',
    'swift',
    'symptomatic',
    'synonymous',
    'taboo',
    'tacit',
    'tacky',
    'talented',
    'tall',
    'tame',
    'tan',
    'tangible',
    'tangy',
    'tart',
    'tasteful',
    'tasteless',
    'tasty',
    'tawdry',
    'tearful',
    'tedious',
    'teeny',
    'teeny-tiny',
    'telling',
    'temporary',
    'ten',
    'tender',
    'tense',
    'tense',
    'tenuous',
    'terrible',
    'terrific',
    'tested',
    'testy',
    'thankful',
    'therapeutic',
    'thick',
    'thin',
    'thinkable',
    'third',
    'thirsty',
    'thirsty',
    'thoughtful',
    'thoughtless',
    'threatening',
    'three',
    'thundering',
    'tidy',
    'tight',
    'tightfisted',
    'tiny',
    'tired',
    'tiresome',
    'toothsome',
    'torpid',
    'tough',
    'towering',
    'tranquil',
    'trashy',
    'tremendous',
    'tricky',
    'trite',
    'troubled',
    'truculent',
    '1',
    'truthful',
    'two',
    'typical',
    'ubiquitous',
    'ugliest',
    'ugly',
    'ultra',
    'unable',
    'unaccountable',
    'unadvised',
    'unarmed',
    'unbecoming',
    'unbiased',
    'uncovered',
    'understood',
    'undesirable',
    'unequal',
    'unequaled',
    'uneven',
    'unhealthy',
    'uninterested',
    'unique',
    'unkempt',
    'unknown',
    'unnatural',
    'unruly',
    'unsightly',
    'unsuitable',
    'untidy',
    'unused',
    'unusual',
    'unwieldy',
    'unwritten',
    'upbeat',
    'uppity',
    'upset',
    'uptight',
    'used',
    'useful',
    'useless',
    'utopian',
    'utter',
    'uttermost',
    'vacuous',
    'vagabond',
    'vague',
    'valuable',
    'various',
    'vast',
    'vengeful',
    'venomous',
    'verdant',
    'versed',
    'victorious',
    'vigorous',
    'violent',
    'violet',
    'vivacious',
    'voiceless',
    'volatile',
    'voracious',
    'vulgar',
    'wacky',
    'waggish',
    'waiting',
    'wakeful',
    'wandering',
    'wanting',
    'warlike',
    'warm',
    'wary',
    'wasteful',
    'watery',
    'weak',
    'wealthy',
    'weary',
    'well-groomed',
    'well-made',
    'well-off',
    'well-to-do',
    'wet',
    'whimsical',
    'whispering',
    'white',
    'whole',
    'wholesale',
    'wicked',
    'wide',
    'wide-eyed',
    'wiggly',
    'wild',
    'willing',
    'windy',
    'wiry',
    'wise',
    'wistful',
    'witty',
    'woebegone',
    'womanly',
    'wonderful',
    'wooden',
    'woozy',
    'workable',
    'worried',
    'worthless',
    'wrathful',
    'wretched',
    'wrong',
    'wry',
    'yellow',
    'yielding',
    'young',
    'youthful',
    'yummy',
    'zany',
    'zealous',
    'zesty',
    'zippy',
    'zonked',
];
const gerunds = [
    'Abiding',
    'Accelerating',
    'Accepting',
    'Accomplishing',
    'Achieving',
    'Acquiring',
    'Acceding',
    'Activating',
    'Adapting',
    'Adding',
    'Addressing',
    'Administering',
    'Admiring',
    'admitting',
    'adopting',
    'advising',
    'affording',
    'agreeing',
    'alerting',
    'alighting',
    'allowing',
    'altering',
    'amusing',
    'analyzing',
    'announcing',
    'annoying',
    'answering',
    'anticipating',
    'apologizing',
    'appearing',
    'applauding',
    'applauding',
    'appointing',
    'appraising',
    'appreciating',
    'approving',
    'arbitrating',
    'arguing',
    'arising',
    'arranging',
    'arresting',
    'arriving',
    'ascertaining',
    'asking',
    'assembling',
    'assessing',
    'assisting',
    'assuring',
    'attaching',
    'attacking',
    'attaining',
    'attempting',
    'attending',
    'attracting',
    'auditing',
    'avoiding',
    'awakening',
    'backing',
    'baking',
    'balancing',
    'banning',
    'banging',
    'baring',
    'bating',
    'bathing',
    'battling',
    'being',
    'beaming',
    'bearing',
    'beating',
    'becoming',
    'begging',
    'beginning',
    'behaving',
    'beholding',
    'belonging',
    'bending',
    'besetting',
    'betting',
    'biding',
    'binding',
    'biting',
    'bleaching',
    'bleeding',
    'blessing',
    'blinding',
    'blinking',
    'blotting',
    'blowing',
    'blushing',
    'boasting',
    'boiling',
    'bolting',
    'bombing',
    'booking',
    'boring',
    'borrowing',
    'bouncing',
    'bowing',
    'boxing',
    'braking',
    'branching',
    'breaking',
    'breathing',
    'breeding',
    'briefing',
    'bringing',
    'broadcasting',
    'bruising',
    'brushing',
    'bubbling',
    'budgeting',
    'building',
    'bumping',
    'burning',
    'bursting',
    'burying',
    'busting',
    'buying',
    'buzzing',
    'calculating',
    'calling',
    'camping',
    'caring',
    'carrying',
    'carving',
    'casting',
    'cataloging',
    'catching',
    'causing',
    'challenging',
    'changing',
    'charging',
    'charting',
    'chasseing',
    'cheating',
    'checking',
    'cheering',
    'chewing',
    'choking',
    'choosing',
    'chopping',
    'claiming',
    'clapping',
    'clarifying',
    'classifying',
    'cleaning',
    'clearing',
    'clinging',
    'clipping',
    'closeting',
    'clothing',
    'coaching',
    'coiling',
    'collecting',
    'coloring',
    'combing',
    'coming',
    'commanding',
    'communicating',
    'comparing',
    'competing',
    'compiling',
    'complaining',
    'completing',
    'composing',
    'computing',
    'conceiving',
    'concentrating',
    'conceptualizing',
    'concerning',
    'concluding',
    'conducting',
    'confessing',
    'confronting',
    'confusing',
    'connecting',
    'conserving',
    'considering',
    'consisting',
    'consolidating',
    'constructing',
    'consulting',
    'containing',
    'continuing',
    'contracting',
    'controlling',
    'converting',
    'coordinating',
    'copying',
    'correcting',
    'correlating',
    'costing',
    'coughing',
    'counseling',
    'counting',
    'covering',
    'cracking',
    'crashing',
    'crawling',
    'creating',
    'creeping',
    'critiquing',
    'crossing',
    'crushing',
    'crying',
    'curing',
    'curling',
    'curving',
    'cutting',
    'cycling',
    'damming',
    'damaging',
    'dancing',
    'daring',
    'dealing',
    'decaying',
    'deceiving',
    'deciding',
    'decorating',
    'defining',
    'delaying',
    'delegating',
    'delighting',
    'delivering',
    'demonstrating',
    'depending',
    'describing',
    'deserting',
    'deserving',
    'designing',
    'destroying',
    'detailing',
    'detecting',
    'determining',
    'developing',
    'devising',
    'diagnosing',
    'digging',
    'directing',
    'disagreeing',
    'disappearing',
    'disapproving',
    'disarming',
    'discovering',
    'disliking',
    'dispensing',
    'displaying',
    'disproving',
    'dissecting',
    'distributing',
    'diving',
    'diverting',
    'dividing',
    'doing',
    'doubling',
    'doubting',
    'drafting',
    'dragging',
    'draining',
    'dramatizing',
    'drawing',
    'dreaming',
    'dressing',
    'drinking',
    'dripping',
    'driveling',
    'dropping',
    'drowning',
    'drumming',
    'drying',
    'dusting',
    'dwelling',
    'earning',
    'eating',
    'editing',
    'educating',
    'eliminating',
    'embarrassing',
    'employing',
    'emptying',
    'enacting',
    'encouraging',
    'ending',
    'enduring',
    'enforcing',
    'engineering',
    'enhancing',
    'enjoying',
    'enlisting',
    'ensuring',
    'entering',
    'entertaining',
    'escaping',
    'establishing',
    'estimating',
    'evaluating',
    'examining',
    'exceeding',
    'exciting',
    'excusing',
    'executing',
    'exercising',
    'exhibiting',
    'existing',
    'expanding',
    'expecting',
    'expediting',
    'experimenting',
    'explaining',
    'exploding',
    'expressing',
    'extending',
    'extracting',
    'facing',
    'facilitating',
    'fading',
    'failing',
    'fancying',
    'fastening',
    'faxing',
    'fearing',
    'feeding',
    'feeling',
    'fencing',
    'fetching',
    'fighting',
    'fileting',
    'filling',
    'filming',
    'finalizing',
    'financing',
    'finding',
    'firing',
    'fitting',
    'fixing',
    'flapping',
    'flashing',
    'fleeing',
    'flinging',
    'floating',
    'flooding',
    'flowing',
    'flowering',
    'flying',
    'folding',
    'following',
    'fooling',
    'forbidding',
    'forcing',
    'forecasting',
    'foregoing',
    'foreseeing',
    'foretelling',
    'forgetting',
    'forgiving',
    'forming',
    'formulating',
    'forsaking',
    'framing',
    'freezing',
    'frightening',
    'frying',
    'gathering',
    'gazing',
    'generating',
    'getting',
    'giving',
    'glowing',
    'gluing',
    'going',
    'governing',
    'grabbing',
    'graduating',
    'grating',
    'greasing',
    'greeting',
    'grinning',
    'grinding',
    'griping',
    'groaning',
    'growing',
    'guaranteeing',
    'guarding',
    'guessing',
    'guiding',
    'hammering',
    'handing',
    'handling',
    'handwriting',
    'hanging',
    'happening',
    'harassing',
    'harming',
    'hating',
    'haunting',
    'heading',
    'healing',
    'heaping',
    'hearing',
    'heating',
    'helping',
    'hiding',
    'hitting',
    'holding',
    'hooking',
    'hoping',
    'hoping',
    'hovering',
    'hugging',
    'humming',
    'hunting',
    'hurrying',
    'hurting',
    'hypothesizing',
    'identifying',
    'ignoring',
    'illustrating',
    'imagining',
    'implementing',
    'impressing',
    'improving',
    'improvising',
    'including',
    'increasing',
    'inducing',
    'influencing',
    'informing',
    'initiating',
    'injecting',
    'injuring',
    'inlaying',
    'innovating',
    'inputting',
    'inspecting',
    'inspiring',
    'installing',
    'instituting',
    'instructing',
    'insuring',
    'integrating',
    'intending',
    'intensifying',
    'interesting',
    'interfering',
    'interlaying',
    'interpreting',
    'interrupting',
    'interviewing',
    'introducing',
    'inventing',
    'inventorying',
    'investigating',
    'inviting',
    'irritating',
    'itching',
    'jailing',
    'jamming',
    'jogging',
    'joining',
    'joking',
    'judging',
    'juggling',
    'jumping',
    'justifying',
    'keeping',
    'keeping',
    'kicking',
    'killing',
    'kissing',
    'kneeling',
    'knitting',
    'knocking',
    'knotting',
    'knowing',
    'labeling',
    'landing',
    'lasting',
    'laughing',
    'launching',
    'laying',
    'leading',
    'leaning',
    'leaping',
    'learning',
    'leavening',
    'lecturing',
    'lading',
    'lending',
    'letting',
    'leveling',
    'licensing',
    'licking',
    'lying',
    'littering',
    'lighting',
    'lightening',
    'likening',
    'listing',
    'listening',
    'livening',
    'loading',
    'locating',
    'locking',
    'logging',
    'longing',
    'looking',
    'losing',
    'loving',
    'maintaining',
    'making',
    'manning',
    'managing',
    'manipulating',
    'manufacturing',
    'mapping',
    'marching',
    'marking',
    'marketing',
    'marrying',
    'matching',
    'mating',
    'mattering',
    'meaning',
    'measuring',
    'meddling',
    'mediating',
    'meeting',
    'melting',
    'melting',
    'memorizing',
    'mending',
    'mentoring',
    'milking',
    'mining',
    'misleading',
    'missing',
    'misspelling',
    'mistaking',
    'misunderstanding',
    'mixing',
    'moaning',
    'modeling',
    'modifying',
    'monitoring',
    'mooring',
    'motivating',
    'mourning',
    'moving',
    'mowing',
    'muddling',
    'mugging',
    'multiplying',
    'murdering',
    'nailing',
    'naming',
    'navigating',
    'needing',
    'negotiating',
    'nesting',
    'nodding',
    'nominating',
    'normalizing',
    'noting',
    'noticing',
    'numbering',
    'obeying',
    'objecting',
    'observing',
    'obtaining',
    'occurring',
    'offending',
    'offering',
    'officiating',
    'opening',
    'operating',
    'ordering',
    'organizing',
    'orienteering',
    'originating',
    'overcoming',
    'overdoing',
    'overdrawing',
    'overflowing',
    'overhearing',
    'overtaking',
    'overthrowing',
    'owing',
    'owning',
    'packing',
    'paddling',
    'painting',
    'parking',
    'parting',
    'participating',
    'passing',
    'pasting',
    'patting',
    'pausing',
    'paying',
    'pecking',
    'pedaling',
    'peeling',
    'peeping',
    'perceiving',
    'perfecting',
    'performing',
    'permitting',
    'persuading',
    'phoning',
    'photographing',
    'picking',
    'piloting',
    'pinching',
    'pining',
    'pinpointing',
    'pioneering',
    'placing',
    'planning',
    'planting',
    'playing',
    'pleading',
    'pleasing',
    'plugging',
    'pointing',
    'poking',
    'polishing',
    'popping',
    'possessing',
    'posting',
    'pouring',
    'practicing',
    'praise ding',
    'praying',
    'preaching',
    'preceding',
    'predicting',
    'preferring',
    'preparing',
    'prescribing',
    'presenting',
    'preserving',
    'presetting',
    'presiding',
    'pressing',
    'pretending',
    'preventing',
    'pricking',
    'printing',
    'processing',
    'procuring',
    'producing',
    'professing',
    'programing',
    'progressing',
    'projecting',
    'promising',
    'promoting',
    'proofreading',
    'proposing',
    'protecting',
    'proving',
    'providing',
    'publicizing',
    'pulling',
    'pumping',
    'punching',
    'puncturing',
    'punishing',
    'purchasing',
    'pushing',
    'putting',
    'qualifying',
    'questioning',
    'quitting',
    'racing',
    'radiating',
    'raining',
    'raising',
    'ranking',
    'rating',
    'reaching',
    'reading',
    'realigning',
    'realizing',
    'reasoning',
    'receiving',
    'recognizing',
    'recommending',
    'reconciling',
    'recording',
    'recruiting',
    'reducing',
    'referring',
    'reflecting',
    'refusing',
    'regretting',
    'regulating',
    'rehabilitating',
    'reigning',
    'reinforcing',
    'rejecting',
    'rejoicing',
    'relating',
    'relaxing',
    'releasing',
    'relying',
    'remaining',
    'remembering',
    'reminding',
    'removing',
    'rendering',
    'reorganizing',
    'repairing',
    'repeating',
    'replacing',
    'replying',
    'reporting',
    'representing',
    'reproducing',
    'requesting',
    'rescuing',
    'researching',
    'resolving',
    'responding',
    'restore ding',
    'restructuring',
    'retiring',
    'retrieving',
    'returning',
    'reviewing',
    'revising',
    'rhyming',
    'riding',
    'riding',
    'ringing',
    'rinsing',
    'rising',
    'risking',
    'robing',
    'rocking',
    'rolling',
    'rotting',
    'rubbing',
    'ruining',
    'ruling',
    'running',
    'rushing',
    'sacking',
    'sailing',
    'satisfying',
    'saving',
    'sawing',
    'saying',
    'scaring',
    'scattering',
    'scheduling',
    'scolding',
    'scorching',
    'scraping',
    'scratching',
    'screaming',
    'screwing',
    'scribbling',
    'scrubbing',
    'sealing',
    'searching',
    'securing',
    'seeing',
    'seeking',
    'selecting',
    'selling',
    'sending',
    'sensing',
    'separating',
    'serving',
    'servicing',
    'setting',
    'settling',
    'sewing',
    'shading',
    'shaking',
    'shaping',
    'sharing',
    'shaving',
    'shearing',
    'shedding',
    'sheltering',
    'shining',
    'shivering',
    'shocking',
    'shoeing',
    'shooting',
    'shopping',
    'showing',
    'shrinking',
    'shrugging',
    'shutting',
    'sighing',
    'signing',
    'signaling',
    'simplifying',
    'sinning',
    'singing',
    'sinking',
    'sipping',
    'siting',
    'sketching',
    'skiing',
    'skipping',
    'slapping',
    'slaying',
    'sleeping',
    'sliding',
    'slinging',
    'slinking',
    'slipping',
    'slitting',
    'slowing',
    'smashing',
    'smelling',
    'smiling',
    'smiting',
    'smoking',
    'snatching',
    'sneaking',
    'sneezing',
    'sniffing',
    'snoring',
    'snowing',
    'soaking',
    'solving',
    'soothing',
    'soothsaying',
    'sorting',
    'sounding',
    'sowing',
    'sparing',
    'sparking',
    'sparkling',
    'speaking',
    'specifying',
    'speeding',
    'spelling',
    'spending',
    'spilling',
    'spinning',
    'spiting',
    'splitting',
    'spoiling',
    'spotting',
    'spraying',
    'spreading',
    'springing',
    'sprouting',
    'squashing',
    'squeaking',
    'squealing',
    'squeezing',
    'staining',
    'stamping',
    'standing',
    'staring',
    'starting',
    'staying',
    'stealing',
    'steering',
    'stepping',
    'sticking',
    'stimulating',
    'stinging',
    'stinking',
    'stirring',
    'stitching',
    'stopping',
    'storing',
    'strapping',
    'streamlining',
    'strengthening',
    'stretching',
    'striding',
    'striking',
    'stringing',
    'striping',
    'striving',
    'stroking',
    'structuring',
    'studying',
    'stuffing',
    'subletting',
    'subtracting',
    'succeeding',
    'sucking',
    'suffering',
    'suggesting',
    'suiting',
    'summarizing',
    'supervising',
    'supplying',
    'supporting',
    'supposing',
    'surprising',
    'surrounding',
    'suspecting',
    'suspending',
    'swearing',
    'sweating',
    'sweeping',
    'swelling',
    'swimming',
    'swinging',
    'switching',
    'symbolizing',
    'synthesizing',
    'systemizing',
    'tabulating',
    'taking',
    'talking',
    'taming',
    'taping',
    'targeting',
    'tasting',
    'teaching',
    'tearing',
    'teasing',
    'telephoning',
    'telling',
    'tempting',
    'terrifying',
    'testing',
    'thanking',
    'thawing',
    'thinking',
    'thriving',
    'throwing',
    'thrusting',
    'ticking',
    'tickling',
    'teeing',
    'timing',
    'tipping',
    'tiring',
    'touching',
    'touring',
    'towing',
    'tracing',
    'trading',
    'training',
    'transcribing',
    'transferring',
    'transforming',
    'translating',
    'transporting',
    'trapping',
    'traveling',
    'treading',
    'treating',
    'trembling',
    'tricking',
    'tripping',
    'trotting',
    'troubling',
    'troubleshooting',
    'trusting',
    'trying',
    'tugging',
    'tumbling',
    'turning',
    'tutoring',
    'twisting',
    'typing',
    'undergoing',
    'understanding',
    'undertaking',
    'undressing',
    'unfastening',
    'unifying',
    'uniting',
    'unlocking',
    'unpacking',
    'unifying',
    'updating',
    'upgrading',
    'upholding',
    'upsetting',
    'using',
    'utilizing',
    'vanishing',
    'verbalizing',
    'verifying',
    'vexing',
    'visiting',
    'wailing',
    'waiting',
    'wakening',
    'walking',
    'wandering',
    'wanting',
    'warming',
    'warning',
    'washing',
    'wasting',
    'watching',
    'watering',
    'wavering',
    'wearing',
    'weaving',
    'wedding',
    'weeping',
    'weighing',
    'welcoming',
    'wending',
    'wetting',
    'whining',
    'whipping',
    'whirling',
    'whispering',
    'whistling',
    'wining',
    'winding',
    'winking',
    'wiping',
    'wishing',
    'withdrawing',
    'withholding',
    'withstanding',
    'wobbling',
    'wondering',
    'working',
    'worrying',
    'wrapping',
    'wrecking',
    'wrestling',
    'wriggling',
    'wringing',
    'writing',
    'x-raying',
    'yawning',
    'yelling',
    'zipping',
    'zooming',
];
const adverbs = [
    'abnormally',
    'absentmindedly',
    'accidentally',
    'acidly',
    'actually',
    'adventurously',
    'afterwards',
    'almost',
    'always',
    'angrily',
    'annually',
    'anxiously',
    'arrogantly',
    'awkwardly',
    'badly',
    'bashfully',
    'beautifully',
    'bitterly',
    'bleakly',
    'blindly',
    'blissfully',
    'boastfully',
    'boldly',
    'bravely',
    'briefly',
    'brightly',
    'briskly',
    'broadly',
    'busily',
    'calmly',
    'carefully',
    'carelessly',
    'cautiously',
    'certainly',
    'cheerfully',
    'clearly',
    'cleverly',
    'closely',
    'coaxingly',
    'colorfully',
    'commonly',
    'continually',
    'coolly',
    'correctly',
    'courageously',
    'crossly',
    'cruelly',
    'curiously',
    'daily',
    'daintily',
    'dearly',
    'deceivingly',
    'delightfully',
    'deeply',
    'defiantly',
    'deliberately',
    'delightfully',
    'diligently',
    'dimly',
    'doubtfully',
    'dreamily',
    'easily',
    'elegantly',
    'energetically',
    'enormously',
    'enthusiastically',
    'equally',
    'especially',
    'even',
    'evenly',
    'eventually',
    'exactly',
    'excitedly',
    'extremely',
    'fairly',
    'faithfully',
    'famously',
    'far',
    'fast',
    'fatally',
    'ferociously',
    'fervently',
    'fiercely',
    'fondly',
    'foolishly',
    'fortunately',
    'frankly',
    'frantically',
    'freely',
    'frenetically',
    'frightfully',
    'fully',
    'furiously',
    'generally',
    'generously',
    'gently',
    'gladly',
    'gleefully',
    'gracefully',
    'gratefully',
    'greatly',
    'greedily',
    'happily',
    'hastily',
    'healthily',
    'heavily',
    'helpfully',
    'helplessly',
    'highly',
    'honestly',
    'hopelessly',
    'hourly',
    'hungrily',
    'immediately',
    'innocently',
    'inquisitively',
    'instantly',
    'intensely',
    'intently',
    'interestingly',
    'inwardly',
    'irritably     ',
    'jaggedly',
    'jealously',
    'joshingly',
    'joyfully',
    'joyously',
    'jovially',
    'jubilantly',
    'judgmentally',
    'justly',
    'keenly',
    'kiddingly',
    'kindheartedly',
    'kindly',
    'knavishly',
    'knottily',
    'knowingly',
    'knowledgeably',
    'kookily',
    'lazily',
    'less',
    'lightly',
    'likely',
    'limply',
    'lively',
    'loftily',
    'longingly',
    'loosely',
    'lovingly',
    'loudly',
    'loyally',
    'madly',
    'majestically',
    'meaningfully',
    'mechanically',
    'merrily',
    'miserably',
    'mockingly',
    'monthly',
    'more',
    'mortally',
    'mostly',
    'mysteriously  ',
    'naturally',
    'nearly',
    'neatly',
    'needily',
    'nervously',
    'never',
    'nicely',
    'noisily',
    'not   ',
    'obediently',
    'obnoxiously',
    'oddly',
    'offensively',
    'officially',
    'often',
    'only',
    'openly',
    'optimistically',
    'overconfidently',
    'owlishly',
    'painfully',
    'partially',
    'patiently',
    'perfectly',
    'physically',
    'playfully',
    'politely',
    'poorly',
    'positively',
    'potentially',
    'powerfully',
    'promptly',
    'properly',
    'punctually',
    'quaintly',
    'quarrelsomely',
    'queasily',
    'queerly',
    'questionably',
    'questioningly',
    'quicker',
    'quickly',
    'quietly',
    'quirkily',
    'quizzically',
    'rapidly',
    'rarely',
    'readily',
    'really',
    'reassuringly',
    'recklessly',
    'regularly',
    'reluctantly',
    'repeatedly',
    'reproachfully',
    'restfully',
    'righteously',
    'rightfully',
    'rigidly',
    'roughly',
    'rudely',
    'sadly',
    'safely',
    'scarcely',
    'scarily',
    'searchingly',
    'sedately',
    'seemingly',
    'seldom',
    'selfishly',
    'separately',
    'seriously',
    'shakily',
    'sharply',
    'sheepishly',
    'shrilly',
    'shyly',
    'silently',
    'sleepily',
    'slowly',
    'smoothly',
    'softly',
    'solemnly',
    'solidly',
    'sometimes',
    'soon',
    'speedily',
    'stealthily',
    'sternly',
    'strictly',
    'successfully',
    'suddenly',
    'surprisingly',
    'suspiciously',
    'sweetly',
    'swiftly',
    'sympathetically',
    'tenderly',
    'tensely',
    'terribly',
    'thankfully',
    'thoroughly',
    'thoughtfully',
    'tightly',
    'tomorrow',
    'too',
    'tremendously',
    'triumphantly',
    'truly',
    'truthfully',
    'ultimately',
    'unabashedly',
    'unaccountably',
    'unbearably',
    'unethically',
    'unexpectedly',
    'unfortunately',
    'unimpressively',
    'unnaturally',
    'unnecessarily',
    'utterly',
    'upbeat',
    'upliftingly',
    'upright',
    'upside-down',
    'upward',
    'upwardly',
    'urgently',
    'usefully',
    'uselessly',
    'usually',
    'utterly',
    'vacantly',
    'vaguely',
    'vainly',
    'valiantly',
    'vastly',
    'verbally',
    'very',
    'viciously',
    'victoriously',
    'violently',
    'vivaciously',
    'voluntarily   ',
    'warmly',
    'weakly',
    'wearily',
    'well',
    'wetly',
    'wholly',
    'wildly',
    'willfully',
    'wisely',
    'woefully',
    'wonderfully',
    'worriedly',
    'wrongly',
    'yawningly',
    'yearly',
    'yearningly',
    'yesterday',
    'yieldingly',
    'youthfully    ',
    'zealously ',
    'zestfully  ',
    'zestily',
];
const verbs = [
    'abide',
    'accelerate',
    'accept',
    'accomplish',
    'achieve',
    'acquire',
    'acted',
    'activate',
    'adapt',
    'add',
    'address',
    'administer',
    'admire',
    'admit',
    'adopt',
    'advise',
    'afford',
    'agree',
    'alert',
    'alight',
    'allow',
    'altered',
    'amuse',
    'analyze',
    'announce',
    'annoy',
    'answer',
    'anticipate',
    'apologize',
    'appear',
    'applaud',
    'applied',
    'appoint',
    'appraise',
    'appreciate',
    'approve',
    'arbitrate',
    'argue',
    'arise',
    'arrange',
    'arrest',
    'arrive',
    'ascertain',
    'ask',
    'assemble',
    'assess',
    'assist',
    'assure',
    'attach',
    'attack',
    'attain',
    'attempt',
    'attend',
    'attract',
    'audited',
    'avoid',
    'awake',
    'back',
    'bake',
    'balance',
    'ban',
    'bang',
    'bare',
    'bat',
    'bathe',
    'battle',
    'be',
    'beam',
    'bear',
    'beat',
    'become',
    'beg',
    'begin',
    'behave',
    'behold',
    'belong',
    'bend',
    'beset',
    'bet',
    'bid',
    'bind',
    'bite',
    'bleach',
    'bleed',
    'bless',
    'blind',
    'blink',
    'blot',
    'blow',
    'blush',
    'boast',
    'boil',
    'bolt',
    'bomb',
    'book',
    'bore',
    'borrow',
    'bounce',
    'bow',
    'box',
    'brake',
    'branch',
    'break',
    'breathe',
    'breed',
    'brief',
    'bring',
    'broadcast',
    'bruise',
    'brush',
    'bubble',
    'budget',
    'build',
    'bump',
    'burn',
    'burst',
    'bury',
    'bust',
    'buy',
    'buzz',
    'calculate',
    'call',
    'camp',
    'care',
    'carry',
    'carve',
    'cast',
    'catalog',
    'catch',
    'cause',
    'challenge',
    'change',
    'charge',
    'chart',
    'chase',
    'cheat',
    'check',
    'cheer',
    'chew',
    'choke',
    'choose',
    'chop',
    'claim',
    'clap',
    'clarify',
    'classify',
    'clean',
    'clear',
    'cling',
    'clip',
    'close',
    'clothe',
    'coach',
    'coil',
    'collect',
    'color',
    'comb',
    'come',
    'command',
    'communicate',
    'compare',
    'compete',
    'compile',
    'complain',
    'complete',
    'compose',
    'compute',
    'conceive',
    'concentrate',
    'conceptualize',
    'concern',
    'conclude',
    'conduct',
    'confess',
    'confront',
    'confuse',
    'connect',
    'conserve',
    'consider',
    'consist',
    'consolidate',
    'construct',
    'consult',
    'contain',
    'continue',
    'contract',
    'control',
    'convert',
    'coordinate',
    'copy',
    'correct',
    'correlate',
    'cost',
    'cough',
    'counsel',
    'count',
    'cover',
    'crack',
    'crash',
    'crawl',
    'create',
    'creep',
    'critique',
    'cross',
    'crush',
    'cry',
    'cure',
    'curl',
    'curve',
    'cut',
    'cycle',
    'dam',
    'damage',
    'dance',
    'dare',
    'deal',
    'decay',
    'deceive',
    'decide',
    'decorate',
    'define',
    'delay',
    'delegate',
    'delight',
    'deliver',
    'demonstrate',
    'depend',
    'describe',
    'desert',
    'deserve',
    'design',
    'destroy',
    'detail',
    'detect',
    'determine',
    'develop',
    'devise',
    'diagnose',
    'dig',
    'direct',
    'disagree',
    'disappear',
    'disapprove',
    'disarm',
    'discover',
    'dislike',
    'dispense',
    'display',
    'disprove',
    'dissect',
    'distribute',
    'dive',
    'divert',
    'divide',
    'do',
    'double',
    'doubt',
    'draft',
    'drag',
    'drain',
    'dramatize',
    'draw',
    'dream',
    'dress',
    'drink',
    'drip',
    'drive',
    'drop',
    'drown',
    'drum',
    'dry',
    'dust',
    'dwell',
    'earn',
    'eat',
    'edited',
    'educate',
    'eliminate',
    'embarrass',
    'employ',
    'empty',
    'enacted',
    'encourage',
    'end',
    'endure',
    'enforce',
    'engineer',
    'enhance',
    'enjoy',
    'enlist',
    'ensure',
    'enter',
    'entertain',
    'escape',
    'establish',
    'estimate',
    'evaluate',
    'examine',
    'exceed',
    'excite',
    'excuse',
    'execute',
    'exercise',
    'exhibit',
    'exist',
    'expand',
    'expect',
    'expedite',
    'experiment',
    'explain',
    'explode',
    'express',
    'extend',
    'extract',
    'face',
    'facilitate',
    'fade',
    'fail',
    'fancy',
    'fasten',
    'fax',
    'fear',
    'feed',
    'feel',
    'fence',
    'fetch',
    'fight',
    'file',
    'fill',
    'film',
    'finalize',
    'finance',
    'find',
    'fire',
    'fit',
    'fix',
    'flap',
    'flash',
    'flee',
    'fling',
    'float',
    'flood',
    'flow',
    'flower',
    'fly',
    'fold',
    'follow',
    'fool',
    'forbid',
    'force',
    'forecast',
    'forego',
    'foresee',
    'foretell',
    'forget',
    'forgive',
    'form',
    'formulate',
    'forsake',
    'frame',
    'freeze',
    'frighten',
    'fry',
    'gather',
    'gaze',
    'generate',
    'get',
    'give',
    'glow',
    'glue',
    'go',
    'govern',
    'grab',
    'graduate',
    'grate',
    'grease',
    'greet',
    'grin',
    'grind',
    'grip',
    'groan',
    'grow',
    'guarantee',
    'guard',
    'guess',
    'guide',
    'hammer',
    'hand',
    'handle',
    'handwrite',
    'hang',
    'happen',
    'harass',
    'harm',
    'hate',
    'haunt',
    'head',
    'heal',
    'heap',
    'hear',
    'heat',
    'help',
    'hide',
    'hit',
    'hold',
    'hook',
    'hop',
    'hope',
    'hover',
    'hug',
    'hum',
    'hunt',
    'hurry',
    'hurt',
    'hypothesize',
    'identify',
    'ignore',
    'illustrate',
    'imagine',
    'implement',
    'impress',
    'improve',
    'improvise',
    'include',
    'increase',
    'induce',
    'influence',
    'inform',
    'initiate',
    'inject',
    'injure',
    'inlay',
    'innovate',
    'input',
    'inspect',
    'inspire',
    'install',
    'institute',
    'instruct',
    'insure',
    'integrate',
    'intend',
    'intensify',
    'interest',
    'interfere',
    'interlay',
    'interpret',
    'interrupt',
    'interview',
    'introduce',
    'invent',
    'inventory',
    'investigate',
    'invite',
    'irritate',
    'itch',
    'jail',
    'jam',
    'jog',
    'join',
    'joke',
    'judge',
    'juggle',
    'jump',
    'justify',
    'keep',
    'kept',
    'kick',
    'kill',
    'kiss',
    'kneel',
    'knit',
    'knock',
    'knot',
    'know',
    'label',
    'land',
    'last',
    'laugh',
    'launch',
    'lay',
    'lead',
    'lean',
    'leap',
    'learn',
    'leave',
    'lecture',
    'led',
    'lend',
    'let',
    'level',
    'license',
    'lick',
    'lie',
    'lifted',
    'light',
    'lighten',
    'like',
    'list',
    'listen',
    'live',
    'load',
    'locate',
    'lock',
    'log',
    'long',
    'look',
    'lose',
    'love',
    'maintain',
    'make',
    'man',
    'manage',
    'manipulate',
    'manufacture',
    'map',
    'march',
    'mark',
    'market',
    'marry',
    'match',
    'mate',
    'matter',
    'mean',
    'measure',
    'meddle',
    'mediate',
    'meet',
    'melt',
    'melt',
    'memorize',
    'mend',
    'mentor',
    'milk',
    'mine',
    'mislead',
    'miss',
    'misspell',
    'mistake',
    'misunderstand',
    'mix',
    'moan',
    'model',
    'modify',
    'monitor',
    'moor',
    'motivate',
    'mourn',
    'move',
    'mow',
    'muddle',
    'mug',
    'multiply',
    'murder',
    'nail',
    'name',
    'navigate',
    'need',
    'negotiate',
    'nest',
    'nod',
    'nominate',
    'normalize',
    'note',
    'notice',
    'number',
    'obey',
    'object',
    'observe',
    'obtain',
    'occur',
    'offend',
    'offer',
    'officiate',
    'open',
    'operate',
    'order',
    'organize',
    'oriented',
    'originate',
    'overcome',
    'overdo',
    'overdraw',
    'overflow',
    'overhear',
    'overtake',
    'overthrow',
    'owe',
    'own',
    'pack',
    'paddle',
    'paint',
    'park',
    'part',
    'participate',
    'pass',
    'paste',
    'pat',
    'pause',
    'pay',
    'peck',
    'pedal',
    'peel',
    'peep',
    'perceive',
    'perfect',
    'perform',
    'permit',
    'persuade',
    'phone',
    'photograph',
    'pick',
    'pilot',
    'pinch',
    'pine',
    'pinpoint',
    'pioneer',
    'place',
    'plan',
    'plant',
    'play',
    'plead',
    'please',
    'plug',
    'point',
    'poke',
    'polish',
    'pop',
    'possess',
    'post',
    'pour',
    'practice',
    'praised',
    'pray',
    'preach',
    'precede',
    'predict',
    'prefer',
    'prepare',
    'prescribe',
    'present',
    'preserve',
    'preset',
    'preside',
    'press',
    'pretend',
    'prevent',
    'prick',
    'print',
    'process',
    'procure',
    'produce',
    'profess',
    'program',
    'progress',
    'project',
    'promise',
    'promote',
    'proofread',
    'propose',
    'protect',
    'prove',
    'provide',
    'publicize',
    'pull',
    'pump',
    'punch',
    'puncture',
    'punish',
    'purchase',
    'push',
    'put',
    'qualify',
    'question',
    'quit',
    'race',
    'radiate',
    'rain',
    'raise',
    'rank',
    'rate',
    'reach',
    'read',
    'realign',
    'realize',
    'reason',
    'receive',
    'recognize',
    'recommend',
    'reconcile',
    'record',
    'recruit',
    'reduce',
    'refer',
    'reflect',
    'refuse',
    'regret',
    'regulate',
    'rehabilitate',
    'reign',
    'reinforce',
    'reject',
    'rejoice',
    'relate',
    'relax',
    'release',
    'rely',
    'remain',
    'remember',
    'remind',
    'remove',
    'render',
    'reorganize',
    'repair',
    'repeat',
    'replace',
    'reply',
    'report',
    'represent',
    'reproduce',
    'request',
    'rescue',
    'research',
    'resolve',
    'respond',
    'restored',
    'restructure',
    'retire',
    'retrieve',
    'return',
    'review',
    'revise',
    'rhyme',
    'rid',
    'ride',
    'ring',
    'rinse',
    'rise',
    'risk',
    'rob',
    'rock',
    'roll',
    'rot',
    'rub',
    'ruin',
    'rule',
    'run',
    'rush',
    'sack',
    'sail',
    'satisfy',
    'save',
    'saw',
    'say',
    'scare',
    'scatter',
    'schedule',
    'scold',
    'scorch',
    'scrape',
    'scratch',
    'scream',
    'screw',
    'scribble',
    'scrub',
    'seal',
    'search',
    'secure',
    'see',
    'seek',
    'select',
    'sell',
    'send',
    'sense',
    'separate',
    'serve',
    'service',
    'set',
    'settle',
    'sew',
    'shade',
    'shake',
    'shape',
    'share',
    'shave',
    'shear',
    'shed',
    'shelter',
    'shine',
    'shiver',
    'shock',
    'shoe',
    'shoot',
    'shop',
    'show',
    'shrink',
    'shrug',
    'shut',
    'sigh',
    'sign',
    'signal',
    'simplify',
    'sin',
    'sing',
    'sink',
    'sip',
    'sit',
    'sketch',
    'ski',
    'skip',
    'slap',
    'slay',
    'sleep',
    'slide',
    'sling',
    'slink',
    'slip',
    'slit',
    'slow',
    'smash',
    'smell',
    'smile',
    'smite',
    'smoke',
    'snatch',
    'sneak',
    'sneeze',
    'sniff',
    'snore',
    'snow',
    'soak',
    'solve',
    'soothe',
    'soothsay',
    'sort',
    'sound',
    'sow',
    'spare',
    'spark',
    'sparkle',
    'speak',
    'specify',
    'speed',
    'spell',
    'spend',
    'spill',
    'spin',
    'spit',
    'split',
    'spoil',
    'spot',
    'spray',
    'spread',
    'spring',
    'sprout',
    'squash',
    'squeak',
    'squeal',
    'squeeze',
    'stain',
    'stamp',
    'stand',
    'stare',
    'start',
    'stay',
    'steal',
    'steer',
    'step',
    'stick',
    'stimulate',
    'sting',
    'stink',
    'stir',
    'stitch',
    'stop',
    'store',
    'strap',
    'streamline',
    'strengthen',
    'stretch',
    'stride',
    'strike',
    'string',
    'strip',
    'strive',
    'stroke',
    'structure',
    'study',
    'stuff',
    'sublet',
    'subtract',
    'succeed',
    'suck',
    'suffer',
    'suggest',
    'suit',
    'summarize',
    'supervise',
    'supply',
    'support',
    'suppose',
    'surprise',
    'surround',
    'suspect',
    'suspend',
    'swear',
    'sweat',
    'sweep',
    'swell',
    'swim',
    'swing',
    'switch',
    'symbolize',
    'synthesize',
    'systemize',
    'tabulate',
    'take',
    'talk',
    'tame',
    'tap',
    'target',
    'taste',
    'teach',
    'tear',
    'tease',
    'telephone',
    'tell',
    'tempt',
    'terrify',
    'test',
    'thank',
    'thaw',
    'think',
    'thrive',
    'throw',
    'thrust',
    'tick',
    'tickle',
    'tie',
    'time',
    'tip',
    'tire',
    'touch',
    'tour',
    'tow',
    'trace',
    'trade',
    'train',
    'transcribe',
    'transfer',
    'transform',
    'translate',
    'transport',
    'trap',
    'travel',
    'tread',
    'treat',
    'tremble',
    'trick',
    'trip',
    'trot',
    'trouble',
    'troubleshoot',
    'trust',
    'try',
    'tug',
    'tumble',
    'turn',
    'tutor',
    'twist',
    'type',
    'undergo',
    'understand',
    'undertake',
    'undress',
    'unfasten',
    'unify',
    'unite',
    'unlock',
    'unpack',
    'untidy',
    'update',
    'upgrade',
    'uphold',
    'upset',
    'use',
    'utilize',
    'vanish',
    'verbalize',
    'verify',
    'vex',
    'visit',
    'wail',
    'wait',
    'wake',
    'walk',
    'wander',
    'want',
    'warm',
    'warn',
    'wash',
    'waste',
    'watch',
    'water',
    'wave',
    'wear',
    'weave',
    'wed',
    'weep',
    'weigh',
    'welcome',
    'wend',
    'wet',
    'whine',
    'whip',
    'whirl',
    'whisper',
    'whistle',
    'win',
    'wind',
    'wink',
    'wipe',
    'wish',
    'withdraw',
    'withhold',
    'withstand',
    'wobble',
    'wonder',
    'work',
    'worry',
    'wrap',
    'wreck',
    'wrestle',
    'wriggle',
    'wring',
    'write',
    'x-ray',
    'yawn',
    'yeil',
    'zip',
    'zoom',
];
const pluralNouns = [
    'aardvarks',
    'airs',
    'airplanes',
    'airports',
    'alarms',
    'alligators',
    'alphabets',
    'ambulances',
    'animals',
    'ankles',
    'armies',
    'answers',
    'ants',
    'antelopes',
    'apples',
    'arms',
    'armchairs',
    'arrows',
    'asparaguses',
    'babies',
    'backs',
    'backbones',
    'bacons',
    'badges',
    'badgers',
    'bags',
    'bagpipes',
    'baits',
    'bakeries',
    'balls',
    'balloons',
    'bamboos',
    'bananas',
    'bands',
    'bandanas',
    'bangles',
    'banjos',
    'banks',
    'baseballs',
    'baskets',
    'basketballs',
    'bats',
    'baths',
    'bathrooms',
    'bathtubs',
    'batteries',
    'battles',
    'bays',
    'beaches',
    'beads',
    'beans',
    'bears',
    'beards',
    'beasts',
    'beats',
    'beauties',
    'beavers',
    'beds',
    'bedrooms',
    'bees',
    'beefs',
    'beetles',
    'bells',
    'belts',
    'benches',
    'berets',
    'berries',
    'bicycles',
    'bikes',
    'birds',
    'birthdays',
    'bites',
    'blacks',
    'blades',
    'blankets',
    'blocks',
    'bloods',
    'blouses',
    'blows',
    'boards',
    'boats',
    'bobcats',
    'bodies',
    'bolts',
    'bones',
    'bonsais',
    'books',
    'bookcases',
    'booklets',
    'boots',
    'borders',
    'bottles',
    'bottoms',
    'boundaries',
    'bows',
    'bowlings',
    'boxes',
    'boys',
    'brains',
    'brakes',
    'branches',
    'brasses',
    'breads',
    'breaks',
    'breakfasts',
    'breaths',
    'bricks',
    'bridges',
    'broccolis',
    'brochures',
    'brothers',
    'brushes',
    'bubbles',
    'buckets',
    'buildings',
    'bulbs',
    'bulls',
    'bulldozers',
    'bumpers',
    'buns',
    'buss',
    'bushes',
    'butters',
    'buttons',
    'cabbages',
    'cacti',
    'cafes',
    'cakes',
    'calculators',
    'calendars',
    'calves',
    'calls',
    'camels',
    'cameras',
    'camps',
    'candles',
    'canoes',
    'canvass',
    'caps',
    'captains',
    'cars',
    'cards',
    'cardboards',
    'cardigans',
    'carpenters',
    'carrots',
    'cartoons',
    'cats',
    'caterpillars',
    'cathedrals',
    'castles',
    'cauliflowers',
    'caves',
    'CDs',
    'ceilings',
    'celeries',
    'cellos',
    'cements',
    'cemeteries',
    'cereals',
    'chains',
    'chairs',
    'chalks',
    'channels',
    'characters',
    'cheeks',
    'cheeses',
    'cheetahs',
    'cherries',
    'chests',
    'chests',
    'chicks',
    'chickens',
    'children',
    'chimpanzees',
    'chins',
    'chives',
    'chocolates',
    'churches',
    'cicadas',
    'cinemas',
    'circles',
    'cities',
    'clams',
    'clarinets',
    'clicks',
    'clocks',
    'closes',
    'closets',
    'cloths',
    'clouds',
    'coaches',
    'coals',
    'coasts',
    'coats',
    'cobwebs',
    'cockroaches',
    'cocoas',
    'coffees',
    'coils',
    'coins',
    'cokes',
    'colds',
    'collars',
    'colleges',
    'colts',
    'combs',
    'comics',
    'commas',
    'computers',
    'copies',
    'corns',
    'costs',
    'cottons',
    'couches',
    'cougars',
    'countries',
    'courses',
    'courts',
    'cousins',
    'cows',
    'crabs',
    'cracks',
    'crackers',
    'crates',
    'crayfishes',
    'crayons',
    'creams',
    'creeks',
    'crickets',
    'crocodiles',
    'crops',
    'crows',
    'crowds',
    'crowns',
    'cucumbers',
    'cups',
    'cupboards',
    'curtains',
    'curves',
    'cushions',
    'cyclones',
    'dads',
    'daffodils',
    'daisies',
    'dances',
    'daughters',
    'days',
    'deeds',
    'denims',
    'dentists',
    'deserts',
    'desks',
    'desserts',
    'detectives',
    'dews',
    'diamonds',
    'dictionaries',
    'dinghies',
    'dinosaurs',
    'diets',
    'dishes',
    'dogs',
    'dolls',
    'dollars',
    'doors',
    'dragons',
    'dragonflies',
    'drains',
    'drawers',
    'dreams',
    'dresses',
    'dressers',
    'drills',
    'drinks',
    'drums',
    'dryers',
    'ducks',
    'ducklings',
    'dungeons',
    'dusts',
    'eagles',
    'ears',
    'earths',
    'earthquakes',
    'eels',
    'eggs',
    'eggplants',
    'elbows',
    'elephants',
    'energies',
    'engines',
    'equipment',
    'evenings',
    'eyes',
    'eyebrows',
    'faces',
    'facts',
    'factories',
    'fairies',
    'families',
    'fans',
    'fangs',
    'farms',
    'fears',
    'feasts',
    'feathers',
    'feet',
    'ferryboats',
    'fields',
    'fights',
    'fingers',
    'fires',
    'fireplaces',
    'fishes',
    'flags',
    'flames',
    'floods',
    'floors',
    'flowers',
    'flutes',
    'flies',
    'foams',
    'fogs',
    'foods',
    'foots',
    'footballs',
    'foreheads',
    'forests',
    'forks',
    'fountains',
    'foxes',
    'frames',
    'freckles',
    'freezers',
    'frogs',
    'frosts',
    'fruits',
    'fuels',
    'furs',
    'furniture',
    'games',
    'garages',
    'gardens',
    'garlics',
    'gases',
    'gates',
    'gears',
    'ghosts',
    'giraffes',
    'girls',
    'glasses',
    'gloves',
    'glues',
    'goals',
    'goats',
    'gold',
    'goldfishes',
    'golfs',
    'gorillas',
    'governments',
    'grapes',
    'grasses',
    'grasshoppers',
    'greases',
    'grills',
    'groups',
    'guitars',
    'gums',
    'gyms',
    'gymnasts',
    'hails',
    'hairs',
    'haircuts',
    'halls',
    'hamburgers',
    'hammers',
    'hamsters',
    'hands',
    'handballs',
    'handles',
    'hardware',
    'harmonicas',
    'harmonies',
    'hats',
    'hates',
    'hawks',
    'heads',
    'headlights',
    'health',
    'hearts',
    'heats',
    'heavens',
    'hedges',
    'heights',
    'helicopters',
    'helmets',
    'helps',
    'hens',
    'hills',
    'hips',
    'hippopotami',
    'histories',
    'holes',
    'holidays',
    'homes',
    'honeys',
    'hoods',
    'hooks',
    'horns',
    'horses',
    'hoses',
    'hospitals',
    'hours',
    'houses',
    'hurricanes',
    'hyenas',
    'ices',
    'icicles',
    'ideas',
    'inks',
    'insects',
    'instruments',
    'Internets',
    'inventions',
    'irons',
    'islands',
    'jackets',
    'jaguars',
    'jails',
    'jams',
    'jars',
    'jaws',
    'jeans',
    'jeeps',
    'jellies',
    'jellyfishes',
    'jets',
    'jewels',
    'jokes',
    'journeys',
    'judges',
    'judos',
    'juices',
    'jumps',
    'jumpers',
    'kangaroos',
    'karats',
    'kayaks',
    'kettles',
    'keys',
    'keyboards',
    'kicks',
    'kisses',
    'kitchens',
    'kites',
    'kittens',
    'knees',
    'knifes',
    'knights',
    'knots',
    'laces',
    'ladybugs',
    'lakes',
    'lambs',
    'lamps',
    'lands',
    'lasagnas',
    'laughs',
    'leafs',
    'leathers',
    'leeks',
    'legs',
    'lemonades',
    'leopards',
    'letters',
    'lettuces',
    'libraries',
    'lifts',
    'lights',
    'lilies',
    'lines',
    'lions',
    'lips',
    'lipsticks',
    'liquids',
    'lists',
    'litters',
    'lizards',
    'loafs',
    'lobsters',
    'locks',
    'lockets',
    'locusts',
    'looks',
    'lotions',
    'loves',
    'lunches',
    'lynxes',
    'macaronies',
    'machines',
    'magazines',
    'magics',
    'magicians',
    'mails',
    'mailboxes',
    'mailmen',
    'makeups',
    'maps',
    'marbles',
    'marks',
    'markets',
    'mascaras',
    'masks',
    'matches',
    'meals',
    'meats',
    'mechanics',
    'medicines',
    'memories',
    'men',
    'menus',
    'messages',
    'metals',
    'mice',
    'middles',
    'milks',
    'milkshakes',
    'mints',
    'minutes',
    'mirrors',
    'mists',
    'mistakes',
    'mittens',
    'Mondays',
    'moneys',
    'monkeys',
    'months',
    'moons',
    'mornings',
    'mosquitos',
    'motorboats',
    'motorcycles',
    'mountains',
    'mouses',
    'moustaches',
    'mouths',
    'musics',
    'mustards',
    'nails',
    'names',
    'napkins',
    'necks',
    'needles',
    'nests',
    'nets',
    'news',
    'nights',
    'noises',
    'noodles',
    'noses',
    'notes',
    'notebooks',
    'numbers',
    'nuts',
    'oaks',
    'oatmeals',
    'oceans',
    'octopuses',
    'offices',
    'oils',
    'olives',
    'onions',
    'oranges',
    'orchestras',
    'ostriches',
    'otters',
    'ovens',
    'owls',
    'oxen',
    'oxygens',
    'oysters',
    'packets',
    'pages',
    'pails',
    'pains',
    'paints',
    'pairs',
    'pajamas',
    'pamphlets',
    'pans',
    'pancakes',
    'pandas',
    'pansies',
    'panthers',
    'pants',
    'papers',
    'parcels',
    'parents',
    'parks',
    'parrots',
    'parties',
    'pastas',
    'pastes',
    'pastries',
    'patches',
    'paths',
    'peas',
    'peaches',
    'peanuts',
    'pears',
    'pedestrians',
    'pelicans',
    'pens',
    'pencils',
    'peppers',
    'perfumes',
    'persons',
    'pests',
    'pets',
    'phones',
    'pianos',
    'pickles',
    'pictures',
    'pies',
    'pigs',
    'pigeons',
    'pillows',
    'pilots',
    'pimples',
    'pins',
    'pipes',
    'pizzas',
    'planes',
    'plants',
    'plantations',
    'plastics',
    'plates',
    'playgrounds',
    'plots',
    'pockets',
    'poisons',
    'polices',
    'policemen',
    'pollutions',
    'ponds',
    'popcorns',
    'poppies',
    'porcupines',
    'postages',
    'postboxes',
    'pots',
    'potatoes',
    'poultries',
    'powders',
    'powers',
    'prices',
    'printers',
    'prisons',
    'pumpkins',
    'puppies',
    'pyramids',
    'queens',
    'questions',
    'quick sands',
    'quills',
    'quilts',
    'rabbits',
    'radios',
    'radishes',
    'rafts',
    'rails',
    'railways',
    'rains',
    'rainbows',
    'raincoats',
    'rainstorms',
    'rakes',
    'rats',
    'raviolis',
    'rays',
    'recorders',
    'rectangles',
    'refrigerators',
    'reindeers',
    'relativess',
    'restaurants',
    'rewards',
    'rhinoceroses',
    'races',
    'riddles',
    'rings',
    'rivers',
    'roads',
    'roasts',
    'rocks',
    'rolls',
    'roofs',
    'rooms',
    'roosters',
    'roses',
    'rowboats',
    'rubbers',
    'sacks',
    'sails',
    'sailboats',
    'sailors',
    'salads',
    'salmons',
    'salts',
    'sands',
    'sandwiches',
    'sardines',
    'sauces',
    'sausages',
    'saws',
    'saxophones',
    'scarecrows',
    'scarfs',
    'schools',
    'scissors',
    'scooters',
    'scorpions',
    'screws',
    'screwdrivers',
    'seas',
    'seagulls',
    'seals',
    'seaplanes',
    'seashores',
    'seasons',
    'seats',
    'seconds',
    'seeds',
    'sentences',
    'servants',
    'shades',
    'shadows',
    'shallots',
    'shampoos',
    'sharks',
    'shears',
    'sheep',
    'sheets',
    'shelves',
    'shells',
    'shields',
    'ships',
    'shirts',
    'shoes',
    'shoemakers',
    'shops',
    'shorts',
    'shoulders',
    'shovels',
    'shoes',
    'sides',
    'sidewalks',
    'signs',
    'signatures',
    'silks',
    'silvers',
    'singers',
    'sinks',
    'sisters',
    'skins',
    'skirts',
    'skies',
    'sleds',
    'slippers',
    'slopes',
    'smokes',
    'snails',
    'snakes',
    'sneezes',
    'snows',
    'snowflakes',
    'snowmen',
    'soaps',
    'soccer balls',
    'socks',
    'sofas',
    'softballs',
    'soldiers',
    'sons',
    'songs',
    'sounds',
    'soups',
    'soybeans',
    'spaces',
    'spades',
    'spaghettis',
    'sparks',
    'sparrows',
    'spears',
    'speedboats',
    'spiders',
    'spikes',
    'spinaches',
    'sponges',
    'spoons',
    'spots',
    'sprouts',
    'spies',
    'squares',
    'squashes',
    'squids',
    'squirrels',
    'stages',
    'staircases',
    'stamps',
    'stars',
    'stations',
    'steams',
    'steels',
    'stems',
    'steps',
    'stews',
    'sticks',
    'stitches',
    'stingers',
    'stomachs',
    'stones',
    'stools',
    'signs',
    'stopwatches',
    'stores',
    'storms',
    'stories',
    'stoves',
    'strangers',
    'straws',
    'streams',
    'strings',
    'submarines',
    'sugars',
    'suits',
    'summers',
    'suns',
    'sunshines',
    'sunflowers',
    'supermarkets',
    'surfboards',
    'surnames',
    'surprises',
    'sushis',
    'swallows',
    'swamps',
    'swans',
    'sweaters',
    'sweatshirts',
    'sweets',
    'swings',
    'switches',
    'swords',
    'swordfishes',
    'syrups',
    'tables',
    'tabletops',
    'tadpoles',
    'tails',
    'targets',
    'taxes',
    'taxis',
    'teas',
    'teachers',
    'teams',
    'teeth',
    'televisions',
    'tents',
    'textbooks',
    'theaters',
    'thistles',
    'thoughts',
    'threads',
    'throats',
    'thrones',
    'thumbs',
    'thunders',
    'thunderstorms',
    'tickets',
    'ties',
    'tigers',
    'tiles',
    'times',
    'tires',
    'toads',
    'toasts',
    'toes',
    'toilets',
    'tomatoes',
    'tongues',
    'toothbrushes',
    'toothpastes',
    'tops',
    'tornados',
    'tortoises',
    'towers',
    'towns',
    'toys',
    'tractors',
    'traffics',
    'trails',
    'trains',
    'transports',
    'trays',
    'trees',
    'triangles',
    'tricks',
    'trips',
    'trombones',
    'troubles',
    'trousers',
    'trucks',
    'trumpets',
    'trunks',
    'tubs',
    'tubas',
    'tugboats',
    'tulips',
    'tunas',
    'tunes',
    'Turkeys',
    'turnips',
    'turtles',
    'TVs',
    'twigs',
    'twilights',
    'twines',
    'umbrellas',
    'valleys',
    'vans',
    'vases',
    'vegetables',
    'veils',
    'veins',
    'vessels',
    'vests',
    'violins',
    'volcanoes',
    'volleyballs',
    'vultures',
    'walls',
    'wallabies',
    'walruses',
    'washers',
    'wasps',
    'wastes',
    'watches',
    'watchmakers',
    'waters',
    'waterfalls',
    'waves',
    'waxes',
    'weapons',
    'weasels',
    'weathers',
    'wedges',
    'whales',
    'wheels',
    'whips',
    'whistles',
    'wildernesses',
    'willows',
    'winds',
    'windows',
    'windscreens',
    'wings',
    'winters',
    'wires',
    'wishes',
    'witches',
    'wolfs',
    'women',
    'woods',
    'wools',
    'words',
    'workshops',
    'worms',
    'wounds',
    'wrens',
    'wrenches',
    'wrinkles',
    'wrists',
    'xylophones',
    'yachts',
    'yaks',
    'yards',
    'yogurts',
    'zebras',
    'zippers',
    'zoos',
];
const animals = [
    'Aardvark',
    'Albatross',
    'Alligator',
    'Alpaca',
    'Anaconda',
    'Angel Fish',
    'Ant',
    'Anteater',
    'Antelope',
    'Archer Fish',
    'Armadillo',
    'Aye-Aye',
    'Baboon',
    'Badger',
    'Bald Eagle',
    'Bandicoot',
    'Barnacle',
    'Barracuda',
    'Basilisk',
    'Bass',
    'Bat',
    'Beaver',
    'Bee',
    'Beetle',
    'BelugaWhale',
    'Bird',
    'Bison',
    'BillyGoat',
    'BlackBear',
    'Blackbird',
    'Blowfish',
    'Boa',
    'Boar',
    'Bob-Cat',
    'Bonobo',
    'BrownBear',
    'Buck',
    'Budgie',
    'Buffalo',
    'Bull',
    'Bullfrog',
    'Butterfly',
    'Buzzard',
    'Caribou',
    'Cheetah',
    'Camel',
    'Canary',
    'Carp',
    'Cat',
    'Caterpillar',
    'Cattle',
    'Catfish',
    'Chameleon',
    'Centipede',
    'Chicken',
    'Chimpanzee',
    'Chihuahua',
    'Chinchilla',
    'Chipmunk',
    'Clam',
    'Chupacabra',
    'ClownFish',
    'Cobra',
    'CockerSpaniel',
    'Cockatiel',
    'Cockatoo',
    'Cockroach',
    'Cod',
    'Coho',
    'Cougar',
    'Cow',
    'Coyote',
    'Crab',
    'Crane',
    'Crawfish',
    'Cray fish',
    'Cricket',
    'Crocodile',
    'Crow',
    'Cuckoo',
    'Cuttlefish',
    'Deer',
    'Dog',
    'Du-gong',
    'Dalmation',
    'Dacshund',
    'Damsel fly',
    'Dart Frog',
    'Dik-dik',
    'Dingo',
    'Dinosaur',
    'Dodo bird',
    'Dolphin',
    'Donkey',
    'Doormouse',
    'Dormouse',
    'Drafthorse',
    'Dove',
    'Dragonfly',
    'Drake',
    'Duck',
    'Platypus',
    'Dungbeetle',
    'Eagle',
    'Earthworm',
    'Earwig',
    'Echidna',
    'Eclectus',
    'Eel',
    'Egret',
    'Elephant',
    'Elk',
    'Emu',
    'Erne',
    'Falcon',
    'Finch',
    'Fish',
    'Firefly',
    'Flamingo',
    'Flatworm',
    'Fly',
    'Ferret',
    'Fox',
    'Frog',
    'Gazelle',
    'Giant',
    'Giraffe',
    'Gnat',
    'Goat',
    'Goose',
    'Gopher',
    'Gorilla',
    'Grasshopper',
    'Groundhog',
    'Hammerhead',
    'Hare',
    'Hawk',
    'Hedgehog',
    'Heron',
    'Herring',
    'Hippopotamus',
    'Horse',
    'Hyena',
    'Hyrax',
    'Iguana',
    'Iguanodon',
    'Impala',
    'Inchworm',
    'Insect',
    'Jellyfish',
    'Jackal',
    'Jackrabbit',
    'Jaguar',
    'JuneBug',
    'Kangaroo',
    'KillerWhale',
    'KingCobra',
    'Kingfisher',
    'Koala',
    'Komodo',
    'Kookaburra',
    'Krill',
    'Lama',
    'Lamb',
    'Lancelet',
    'Leech',
    'Lemming',
    'Lemur',
    'Leopard',
    'Lice',
    'Lion',
    'Lionfish',
    'Llama',
    'Lobster',
    'Lynx',
    'Manatee',
    'Man-Of-War',
    'Mantis',
    'Marmot',
    'Marsupials',
    'Meerkat',
    'Mink',
    'Mole',
    'Mollusks',
    'Mongoose',
    'Monkey',
    'Moose',
    'MountainLion',
    'Mouse',
    'Mule',
    'Muskox',
    'Muskrat',
    'Narwhal',
    'Nautilus',
    'Newt ',
    'Ocelot',
    'Octopus',
    'Opossum',
    'Orangutan',
    'Orca',
    'Osprey',
    'Ostrich',
    'Otter',
    'Owl',
    'Ox',
    'Panda',
    'Panther',
    'Peacock',
    'Pelican',
    'Penguin',
    'Pig',
    'Pigeon',
    'Platypus',
    'Polar Bear',
    'Porcupine',
    'Mantis',
    'Prawn',
    'Puma',
    'Quail',
    'Quetzal',
    'Rabbit',
    'Raccoon',
    'Rat',
    'Ray',
    'Reindeer',
    'Rhino',
    'Ringworm',
    'Rhinoceros',
    'Robin',
    'Rooster',
    'Roundworm',
    'Salmon',
    'Sandpiper',
    'Seahorse',
    'Seal',
    'anemone',
    'SeaLion',
    'SeaUrchin',
    'Scallop',
    'Scorpion',
    'Shark',
    'Sheep',
    'Shrimp',
    'Skunks',
    'Sloth',
    'Slugs',
    'Snails',
    'Snake',
    'Sponge',
    'Squid',
    'Squirrel',
    'Starfish',
    'Stork',
    'Swan',
    'Swordfish',
    'Tapir',
    'TasmanianDevil',
    'Tiger',
    'Tadpole',
    'Tamarin',
    'Tapeworm',
    'Tarantula',
    'Tarpan',
    'TazmanianDevil',
    'TazmanianTiger',
    'Terrapin',
    'Tick',
    'TigerShark',
    'Tortoise',
    'Trout',
    'Turkey',
    'Turtle',
    'Uakari',
    'Urchin',
    'Urutu',
    'Vicuna',
    'Viper',
    'Vulture',
    'VampireBat',
    'Velociraptor',
    'Vole',
    'Vervet',
    'Walrus',
    'Warbler',
    'Warthog',
    'Wasp',
    'Wallaby',
    'Whale',
    'WhaleShark',
    'WhiteRhino',
    'Whippet',
    'Whooper',
    'Weasel',
    'Weevil',
    'Wolf',
    'WolfSpider',
    'Wolverine',
    'Woodchuck',
    'Woodpecker',
    'Widow Spider',
    'Wren',
    'Wombat',
    'Wildcat',
    'Wildebeest',
    'Yak',
    'Yeti',
    'Yorkshire terrier',
    'Zander',
    'Zebra',
    'Zorilla',
    'Zebu',
];
const classes = [
    'Artificer',
    'Barbarian',
    'Bard',
    'Cleric',
    'Druid',
    'Fighter',
    'Monk',
    'Paladin',
    'Ranger',
    'Rogue',
    'Sorcerer',
    'Warlock',
    'Wizard',
];
const backgrounds = [
    'Acolyte',
    'Anthropologist',
    'Archaeologist',
    'Athlete',
    'Azorius Functionary',
    'Black Fist Double Agent',
    'Boros Legionnaire',
    'Caravan Specialist',
    'Celebrity Adventurers Scion',
    'Charlatan',
    'City Watch',
    'Clan Crafter',
    'Cloistered Scholar',
    'Cormanthor Refugee',
    'Courtier',
    'Criminal',
    'Dimir Operative',
    'Dissenter',
    'Dragon Casualty',
    'Earthspur Miner',
    'Entertainer',
    'Faceless',
    'Faction Agent',
    'Failed Merchant',
    'Far Traveler',
    'Fisher',
    'Folk Hero',
    'Gambler',
    'Gate Urchin',
    'Gladiator',
    'Golgari Agent',
    'Gruul Anarch',
    'Guild Artisan',
    'Guild Merchant',
    'Harborfolk',
    'Haunted One',
    'Hermit',
    'Hillsfar Merchant',
    'Hillsfar Smuggler',
    'House Agent',
    'Inheritor',
    'Initiate',
    'Inquisitor',
    'Investigator',
    'Iron Route Bandit',
    'Izzet Engineer',
    'Knight',
    'Knight of the Order',
    'Marine',
    'Mercenary Veteran',
    'Mulmaster Aristocrat',
    'Noble',
    'Orzhov Representative',
    'Outlander',
    'Phlan Insurgent',
    'Phlan Refugee',
    'Pirate',
    'Plaintiff',
    'Rakdos Cultist',
    'Rival Intern',
    'Sage',
    'Sailor',
    'Secret Identity',
    'Selesnya Initiate',
    'Shade Fanatic',
    'Shipwright',
    'Simic Scientist',
    'Smuggler',
    'Soldier',
    'Spy',
    'Stojanow Prisoner',
    'Ticklebelly Nomad',
    'Trade Sheriff',
    'Urban Bounty Hunter',
    'Urchin',
    'Uthgardt Tribe Member',
    'Vizier',
    'Waterdhavian Noble',
];
const races = [
    'Aarakocra',
    'Aasimar',
    'Aetherborn',
    'Aven',
    'Bugbear',
    'Centaur',
    'Changeling',
    'Dragonborn',
    'Dwarf',
    'Elf',
    'Firbolg',
    'Genasi',
    'Gith',
    'Gnome',
    'Goblin',
    'Goliath',
    'Half-Elf',
    'Half-Orc',
    'Halfling',
    'Hobgoblin',
    'Human',
    'Kalashtar',
    'Kenku',
    'Khenra',
    'Kobold',
    'Kor',
    'Lizardfolk',
    'Locathah',
    'Loxodon',
    'Merfolk',
    'Minotaur',
    'Naga',
    'Orc',
    'Shifter',
    'Simic Hybrid',
    'Siren',
    'Tabaxi',
    'Tiefling',
    'Tortle',
    'Triton',
    'Vampire',
    'Vedalken',
    'Verdan',
    'Warforged',
    'Yuan-ti Pureblood',
]
// const words = {
//     nouns: nouns,
//     adjectives: adjectives,
//     gerunds: gerunds,
//     adverbs: adverbs,
//     verbs: verbs,
//     pluralNouns: pluralNouns,
//     animals: animals,
// };
function getRandom(arr){
    return arr[Math.floor(Math.random() * arr.length)];
}

var randomAdjective = getRandom(adjectives);
var randomNoun = getRandom(nouns);
var randomGerund = getRandom(gerunds);
var randomAdverb = getRandom(adverbs);
var randomVerb = getRandom(verbs);
var randomPluralNoun = getRandom(pluralNouns);
var randomAnimal = getRandom(animals);
var randomRace = getRandom(races);
var randomClass = getRandom(classes);
var randomBackground = getRandom(backgrounds);
var randomPageName = _.capitalize(randomAdjective) + ' ' + randomRace;
var backupRandomPageName = _.capitalize(randomAdverb) + ' ' + _.capitalize(randomAdjective) + ' ' + randomRace;

function slugify(text) {
    var slug = "";
    var textLower = text.toLowerCase();
    // Letter "e"
    slug = textLower
        .replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e")
        // Letter "a"
        .replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a")
        // Letter "o"
        .replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o")
        // Letter "u"
        .replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u")
        // Letter "d"
        .replace(/đ/gi, "d")
        // Trim the last whitespace
        .replace(/\s*$/g, "")
        // Change whitespace to "-"
        .replace(/\s+/g, "-")
        //remove special characters
        .replace(/[^\w-]+/g, "")
        // & to and
        .replace(/&/g, `-and-`)
        // -- to -
        .replace(/--/g, `-`);
    return slug;
}
export {
    randomAdjective,
    randomNoun,
    randomGerund,
    randomAdverb,
    randomVerb,
    randomPluralNoun,
    randomAnimal,
    randomRace,
    randomClass,
    randomBackground,
    randomPageName,
    backupRandomPageName,
    slugify,
};